import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

const SECTIONS = [
  {
    title: "1. What we use",
    body: "Savy Kerno uses a small amount of browser storage that is strictly necessary to run the service: a sign-in session token (an essential cookie or local-storage entry, depending on how you signed in) and your interface preferences. Without the session storage you cannot stay signed in.",
  },
  {
    title: "2. What we do not use",
    body: "We do not use advertising trackers, cross-site tracking cookies, or third-party analytics cookies on the dashboard or public website. No cookie consent banner is therefore required for advertising cookies — there are none to consent to.",
  },
  {
    title: "3. Third-party content",
    body: "If a page ever embeds third-party content that sets its own cookies (for example a payment checkout hosted by our payment provider), those cookies are governed by that provider's policy and are set only when you use that feature.",
  },
  {
    title: "4. Managing storage",
    body: "You can clear site storage in your browser settings at any time. Clearing it signs you out but does not delete your account or data.",
  },
  {
    title: "5. Review status",
    body: "This policy is a working draft pending qualified legal review before paid launch.",
  },
];

export default function Cookies() {
  return (
    <div className="min-h-screen bg-white" data-testid="cookies-page">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-[#111111]">
          <BrandLogo size={22} /> <span className="font-semibold">Savy Kerno</span>
        </Link>
        <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">Cookie Policy</h1>
        <p className="mt-3 text-sm text-neutral-500">Last updated November 2026 · Draft pending legal review</p>
        <div className="mt-8 space-y-6">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-base font-bold text-[#111111]">{s.title}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-neutral-600">{s.body}</p>
            </section>
          ))}
        </div>
        <div className="mt-12 flex gap-4 border-t border-neutral-100 pt-6 text-xs text-neutral-400">
          <Link to="/privacy" className="hover:text-[#111111]">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-[#111111]">Terms of Service</Link>
          <Link to="/ai-calling-policy" className="hover:text-[#111111]">AI Calling & Recording</Link>
        </div>
      </div>
    </div>
  );
}
